import { RENDERER_TYPES } from "../../../enums";

const AMBASSADOR_LIST_COLUMNS = [
  { field: "expandable" },
  {
    title: "Name",
    field: "firstName",
    dataType: "string",
    rendererType: RENDERER_TYPES.FULL_NAME_WITH_AVATAR,
  },
  { title: "Title", field: "title", dataType: "string" },
  { title: "Company", field: "company", dataType: "string" },
  {
    title: "Est. Employees",
    field: "no_of_emp",
    dataType: "string",
  },
  {
    title: "Industry",
    field: "industry",
    dataType: "string",
  },
  {
    title: "Rate",
    field: "round_table_package_12_rate",
    dataType: "string",
    rendererType: RENDERER_TYPES.AMOUNT,
  },
  { title: "Action", rendererType: RENDERER_TYPES.ACTION },
];

const AMBASSADOR_LIST_ROWS = [];

export { AMBASSADOR_LIST_COLUMNS, AMBASSADOR_LIST_ROWS };
